import React from 'react';
import { ErrorBoundary as ErrorBoundaryFc } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

function ErrorBoundary({ children }) {
    const onResetHandler = details => {
        // Reset the state of your app so the error doesn't happen again
        console.log('Log: ErrorBoundary -> onResetHandler -> details:', details);
    };
    const logError = (error, info) => {
        // Do something with the error, e.g. log to an external API
    };

    return (
        <ErrorBoundaryFc FallbackComponent={ErrorFallback} onError={logError} onReset={onResetHandler}>
            {children}
        </ErrorBoundaryFc>
    );
}

export default ErrorBoundary;
